import { mergeTemplate } from './base-template';

export const anwaltTemplate = mergeTemplate({
  name: 'Anwaltskanzlei',
  icon: '⚖️',
  settings: {
    primaryColor: '#1e3a5f',
    accentColor: '#ca8a04',
    fontStack: 'serif',
    stylePreset: 'editorial',
    designDensity: 'airy',
    pageAngebot: {
      heroTitle: 'Unsere Rechtsdienstleistungen',
      heroSubtitle: 'Klare Pakete für Ihre rechtlichen Anliegen',
      packages: [
        { name: 'Erstberatung', price: 'CHF 250', description: '60-Minuten Analyse Ihrer Rechtslage', features: 'Ersteinschätzung, Handlungsempfehlung, Kostentransparenz', highlighted: false },
        { name: 'Mandat', price: 'ab CHF 350/h', description: 'Umfassende Rechtsvertretung', features: 'Schriftverkehr, Verhandlung, Vertragsprüfung, Fristverwaltung', highlighted: true },
        { name: 'Prozessvertretung', price: 'nach Aufwand', description: 'Vertretung vor Gericht', features: 'Klageschrift, Beweisführung, Verhandlung, Berufung', highlighted: false },
      ],
      ctaTitle: 'Rechtssicherheit beginnt mit einem Gespräch',
      ctaText: 'Vereinbaren Sie Ihre Erstberatung — unverbindlich und transparent.',
      ctaButtonText: 'Termin vereinbaren',
    },
    pageMethoden: {
      heroTitle: 'Unser Vorgehen',
      heroSubtitle: 'Strukturiert, transparent, ergebnisorientiert',
      introText: 'Jeder Fall ist einzigartig. Unser bewährter Prozess stellt sicher, dass wir Ihre Interessen bestmöglich vertreten.',
      steps: [
        { title: 'Fallanalyse', description: 'Umfassende Prüfung Ihrer Unterlagen und Rechtslage' },
        { title: 'Strategie', description: 'Entwicklung einer massgeschneiderten Vorgehensweise' },
        { title: 'Verhandlung', description: 'Durchsetzung Ihrer Interessen — aussergerichtlich oder vor Gericht' },
        { title: 'Abschluss', description: 'Dokumentation, Nachbetreuung und Prävention' },
      ],
      tools: [
        { name: 'Vertragsdatenbank', description: 'Schweizer Vertragsvorlagen und Muster' },
        { name: 'Fristen-Management', description: 'Automatische Fristenkontrolle und Erinnerungen' },
        { name: 'Sichere Kommunikation', description: 'Verschlüsselte Mandantenkommunikation' },
      ],
      philosophyTitle: 'Unsere Rechtsphilosophie',
      philosophyText: 'Wir glauben an Transparenz, faire Kosten und lösungsorientiertes Handeln. Prozesse sind immer nur das letzte Mittel.',
    },
    pageUeberMich: {
      heroTitle: 'Unsere Kanzlei',
      heroSubtitle: 'Erfahrung trifft Engagement',
      introText: 'Seit über 15 Jahren vertreten wir Mandanten in allen Bereichen des Wirtschafts- und Privatrechts.',
      imageUrl: '',
      timeline: [
        { year: '2008', text: 'Gründung der Kanzlei' },
        { year: '2015', text: 'Erweiterung um Steuer- und Wirtschaftsrecht' },
        { year: '2022', text: 'Spezialisierung Digitales Recht und Datenschutz' },
      ],
      values: [
        { title: 'Integrität', description: 'Kompromisslose Ehrlichkeit und ethisches Handeln' },
        { title: 'Kompetenz', description: 'Kontinuierliche Weiterbildung und Spezialisierung' },
        { title: 'Effizienz', description: 'Zielorientiert und kostenbewusst für unsere Mandanten' },
      ],
      certifications: 'SAV-zertifiziert, Fachanwalt Wirtschaftsrecht',
    },
  },
  components: {
    header: {
      companyName: 'Kanzlei Muster',
      logoText: 'KM',
      navItems: ['Leistungen', 'Vorgehen', 'Kanzlei', 'Kontakt'],
      ctaText: 'Erstberatung',
    },
    hero: {
      title: 'Recht. Klar. Durchsetzbar.',
      subtitle:
        'Beratung und Vertretung mit Struktur und Fokus auf Ergebnisse.',
      primaryBtn: 'Erstberatung',
      secondaryBtn: 'Kompetenzen',
    },
    trust: {
      items: [
        { value: 'Vertraulich', label: 'Diskretion' },
        { value: 'Präzise', label: 'Struktur' },
        { value: 'Erfahren', label: 'Praxis' },
        { value: 'Lokal', label: 'Region' },
      ],
    },
    services: {
      title: 'Kompetenzen',
      subtitle: 'Ausgewählte Rechtsgebiete.',
      items: [
        {
          icon: '📄',
          title: 'Vertragsrecht',
          text: 'Erstellung, Prüfung, Verhandlung – praxisnah.',
        },
        {
          icon: '🏢',
          title: 'Gesellschaftsrecht',
          text: 'Gründung, Umstrukturierung, Governance.',
        },
        {
          icon: '⚖️',
          title: 'Prozessführung',
          text: 'Vertretung, Strategie, Durchsetzung.',
        },
      ],
    },
    benefits: {
      title: 'Arbeitsweise',
      subtitle: '',
      items: [
        {
          title: 'Klare Einschätzung',
          text: 'Realistische Chancen-/Risikoabwägung.',
        },
        {
          title: 'Saubere Dokumentation',
          text: 'Transparente Schritte und Entscheidungen.',
        },
        {
          title: 'Direkte Kommunikation',
          text: 'Kurz, verständlich, ohne Umwege.',
        },
      ],
    },
    team: {
      title: 'Unser Team',
      subtitle: 'Erfahrung und Spezialisierung.',
      members: [
        {
          name: 'lic. iur. Stefan Muster',
          role: 'Rechtsanwalt, Partner',
          image: '',
          bio: 'Spezialisiert auf Vertrags- und Gesellschaftsrecht. Über 15 Jahre Berufserfahrung.',
        },
        {
          name: 'Dr. iur. Laura Keller',
          role: 'Rechtsanwältin',
          image: '',
          bio: 'Schwerpunkte Arbeitsrecht und Datenschutz. Zugelassen in Zürich und Bern.',
        },
      ],
    },
    testimonials: {
      title: 'Mandantenstimmen',
      items: [
        {
          quote: 'Schnell, präzise und lösungsorientiert.',
          author: 'Mandant',
          role: 'Unternehmen',
        },
        {
          quote: 'Die Erstberatung war klar strukturiert und hat mir sofort Orientierung gegeben.',
          author: 'Andrea S.',
          role: 'Privatperson',
        },
        {
          quote: 'Hervorragende Vertretung bei einer Vertragsstreitigkeit. Professionell und diskret.',
          author: 'Marco B.',
          role: 'KMU-Inhaber',
        },
        {
          quote: 'Faire Kosten, klare Kommunikation und ein sehr gutes Ergebnis.',
          author: 'Elisabeth H.',
          role: 'Geschäftsführerin',
        },
        {
          quote: 'Die Kanzlei hat unsere Firmengründung reibungslos begleitet. Jederzeit wieder.',
          author: 'Daniel & Corinne F.',
          role: 'Start-up-Gründer',
        },
      ],
    },
    faq: {
      title: 'FAQ',
      items: [
        {
          question: 'Wie läuft die Erstberatung ab?',
          answer:
            'Wir klären Ziele, Sachverhalt und Optionen und geben eine erste Einschätzung.',
        },
        {
          question: 'Wie werden Kosten berechnet?',
          answer:
            'Je nach Mandat pauschal oder nach Aufwand – transparent vereinbart.',
        },
        {
          question: 'Welche Rechtsgebiete decken Sie ab?',
          answer: 'Wir sind auf Vertragsrecht, Gesellschaftsrecht, Arbeitsrecht und Datenschutz spezialisiert. Für andere Gebiete vermitteln wir Sie an bewährte Kolleginnen und Kollegen.',
        },
        {
          question: 'Vertreten Sie auch vor Gericht?',
          answer: 'Ja, wir vertreten Mandanten vor allen kantonalen und eidgenössischen Gerichten. Wir streben jedoch immer zuerst eine aussergerichtliche Lösung an, wenn dies sinnvoll ist.',
        },
      ],
    },
    cta: {
      title: 'Erstberatung vereinbaren',
      subtitle: 'Vertraulich und strukturiert.',
    },
    footer: {
      companyName: 'Kanzlei Muster',
      tagline: 'Rechtsberatung in Ihrer Region.',
    },
  },
});
